import styled from 'styled-components';
import { Popper } from '@mui/material';

import colors from '../../../../styles/colors';

const StyledImage = styled.img`
  margin-bottom: 10px;
  width: 50%;
  height: auto;
  cursor: pointer;
  border-radius: 5px;
  align-self: center;
`;

const StyledEnlarger = styled(Popper)`
  z-index: 3000;
  width: 100vw;
  height: 100vh;
  background: ${colors.base.beta}BB;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  
  img {
    max-width: 99vw;
    max-height: 99vh;
    border-radius: 10px;
  }
`;

export {
  StyledImage,
  StyledEnlarger,
};
